module.exports = __webpack_public_path__ + "img/more_circle.8e36133c.svg";